import { RefreshDouble } from 'iconoir-react'
import { useMemo } from 'react'
import SimpleTable from 'app/components/table/SimpleTable'
import { appointmentTypesUnifiedColumns } from 'app/table-columns/appointment-types-unified'
import { AIAgentConfigurationType } from 'app/types/entities'
import { AppointmentTypeType } from 'app/types/entities'
import type { UseAvailabilityAppointmentTypesReturn } from './useAvailabilityAppointmentTypes'

export type AvailabilityAppointmentTypesComponentProps = UseAvailabilityAppointmentTypesReturn

export function AvailabilityAppointmentTypesComponent(props: AvailabilityAppointmentTypesComponentProps) {
  const {
    rows,
    agentConfigState,
    isSyncing,
    isCarestack,
    allowDoubleBooking,
    excludableAppointmentTypes,
    onFieldChange,
    openEditAppointmentTypeModal,
    onRefreshClick,
    handleAppointmentCategoryChange,
  } = props

  const columns = useMemo(
    () =>
      appointmentTypesUnifiedColumns({
        onEditAppointmentTypeClick: openEditAppointmentTypeModal,
        onFieldChange,
        allowDoubleBooking,
        excludableAppointmentTypes,
        agentConfig: agentConfigState as AIAgentConfigurationType,
        isCarestack,
      }),
    [allowDoubleBooking, agentConfigState, isCarestack],
  )

  return (
    <div className="mt-4 flex flex-col gap-4">
      <div className="flex items-center justify-start">
        <button className="btn btn-xs btn-tertiary gap-2" disabled={isSyncing} onClick={() => onRefreshClick()}>
          <RefreshDouble className={isSyncing ? `animate-spin` : ``} />
          {` `}
          <p>{isCarestack ? `Sync production types` : `Sync appointment types`}</p>
        </button>
      </div>
      <SimpleTable columns={columns} data={rows} noDataMessage="No appointment types found" hideFooter={true} />
    </div>
  )
}
